import React, { useState, useEffect } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaClock,
  FaArrowUp,
  FaPaperPlane,
} from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [showBackToTop, setShowBackToTop] = useState(false);
  const currentYear = new Date().getFullYear();

  // Show/hide back-to-top button based on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email.trim()) {
      alert(`Thank you for subscribing with ${email}!`);
      setEmail("");
    } else {
      alert("Please enter a valid email address.");
    }
  };

  const quickLinks = [
    { name: "Home", href: "#" },
    { name: "About Us", href: "#about" },
    { name: "Admission", href: "#admission" },
    { name: "Placement", href: "#placement" },
    { name: "Gallery", href: "#gallery" },
    { name: "Contact", href: "#contact" },
  ];

  const courses = [
    { name: "FITTER", href: "#fitter" },
    { name: "ELECTRICIAN", href: "#electrician" },
  ];

  const socialLinks = [
    { icon: FaFacebookF, href: "#", label: "Facebook", color: "hover:bg-blue-600" },
    { icon: FaTwitter, href: "#", label: "Twitter", color: "hover:bg-sky-500" },
    { icon: FaInstagram, href: "#", label: "Instagram", color: "hover:bg-pink-600" },
    { icon: FaLinkedinIn, href: "#", label: "LinkedIn", color: "hover:bg-blue-700" },
  ];

  return (
    <>
      <footer className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0 -z-10 opacity-20">
          <div className="absolute top-0 left-0 h-64 w-64 rounded-full bg-green-500 blur-3xl" />
          <div className="absolute bottom-0 right-0 h-96 w-96 rounded-full bg-orange-500 blur-3xl" />
        </div>

        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            <div>
              <div className="flex items-center space-x-3">
                <img
                  className="h-12 w-auto object-contain transition-transform hover:scale-105"
                  src="/logo.png"
                  alt="ITI Bhaupur Logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://via.placeholder.com/48?text=ITI";
                  }}
                />
              </div>
              <p className="mt-4 text-sm text-gray-300 leading-relaxed">
                Empowering youth with industry‑ready skills. Our mission is to
                provide quality technical education and shape future professionals.
              </p>
              <div className="mt-4 flex space-x-3">
                {socialLinks.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.href}
                    className={`rounded-full bg-gray-700 p-2 text-gray-300 transition-all duration-300 hover:scale-110 hover:shadow-lg ${social.color} hover:text-white`}
                    aria-label={social.label}
                  >
                    <social.icon className="h-4 w-4" />
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white relative inline-block after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-8 after:bg-green-500 after:rounded-full">
                Quick Links
              </h3>
              <ul className="mt-4 space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-300 transition hover:translate-x-1 hover:text-green-400 inline-block"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white relative inline-block after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-8 after:bg-orange-500 after:rounded-full">
                Our Courses
              </h3>
              <ul className="mt-4 space-y-2">
                {courses.map((course) => (
                  <li key={course.name}>
                    <a
                      href={course.href}
                      className="text-sm text-gray-300 transition hover:translate-x-1 hover:text-orange-400 inline-block"
                    >
                      {course.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white relative inline-block after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-8 after:bg-green-500 after:rounded-full">
                Contact Info
              </h3>
              <ul className="mt-4 space-y-3">
                <li className="flex items-start space-x-3">
                  <FaMapMarkerAlt className="mt-1 h-4 w-4 text-green-400" />
                  <span className="text-sm text-gray-300">
                    Village - Kushnow, Post - Bhaupur,
                    <br />
                    District - Jaunpur,
                    <br />
                    Pin - 222136 (Uttar Pradesh)
                  </span>
                </li>
                <li className="flex items-center space-x-3">
                  <FaPhoneAlt className="h-4 w-4 text-green-400" />
                  <span className="text-sm text-gray-300">
                    +91 9956808612, +91 8090586416
                  </span>
                </li>
                <li className="flex items-center space-x-3">
                  <FaEnvelope className="h-4 w-4 text-green-400" />
                  <a
                    href="mailto:shardaiti2014@gmail.com"
                    className="text-sm text-gray-300 hover:text-green-400 transition"
                  >
                    shardaiti2014@gmail.com
                  </a>
                </li>
                <li className="flex items-center space-x-3">
                  <FaClock className="h-4 w-4 text-green-400" />
                  <span className="text-sm text-gray-300">
                    Mon – Sat: 9:00 AM – 6:00 PM
                  </span>
                </li>
              </ul>
              <div className="mt-6">
                <h4 className="text-sm font-semibold text-white mb-2">Subscribe to Newsletter</h4>
                <form onSubmit={handleSubscribe} className="flex">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email"
                    className="flex-1 rounded-l-md bg-gray-700 px-3 py-2 text-sm text-white placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-green-500"
                    required
                  />
                  <button
                    type="submit"
                    className="rounded-r-md bg-gradient-to-r from-green-600 to-orange-500 px-3 py-2 text-sm font-medium text-white transition hover:opacity-90 flex items-center gap-1"
                  >
                    <FaPaperPlane className="h-3 w-3" />
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="mt-8 border-t border-gray-700 pt-8 text-center">
            <p className="text-sm text-gray-400">
              &copy; {currentYear} ITI Bhaupur. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 z-50 rounded-full bg-gradient-to-r from-green-600 to-orange-500 p-3 text-white shadow-lg transition-all duration-300 hover:scale-110 ${
          showBackToTop
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10 pointer-events-none"
        }`}
        aria-label="Back to top"
      >
        <FaArrowUp className="h-5 w-5" />
      </button>
    </>
  );
};

export default Footer;